import { FormViewField } from 'components/FormView';

export default {
    formName: 'RecallCreditNotesFilterRow',
    validate: null,
    rowModelType: 'serverSide',
    parameters: [
        {
            id: 0,
            type: 'EX_LOOKUP_FIELD',
            visible: true,
            props: {
                label: 'Entity',
                size: 'small',
                name: 'Entity',
                lookupName: 'Entity',
                disabled: false,
                required: true
            }
        },
        {
            id: 1,
            type: 'EX_LOOKUP_FIELD',
            props: {
                label: 'Username',
                name: 'Username',
                lookupName: 'Username',
                placeholder: '',
                size: 'medium',
                suppressDescription: true
            }
        },
        {
            id: 2,
            type: 'EX_LOOKUP_FIELD',
            props: {
                label: 'Customer',
                name: 'CustomerId',
                lookupName: 'Customer',
                placeholder: '',
                size: 'medium'
            }
        }
    ] as FormViewField[]
};
